import {Injectable} from '@angular/core';
import Dexie from "dexie";
import {User} from "../shared/interfaces/User";
import {IndexedDbService} from "./indexed-db.service";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private db: Dexie;

  constructor(private dexieDBService: IndexedDbService) {
  }

  async completeUserInIndexedDB(user: User) {

    // Open the database and retrieve the user object store
    await this.dexieDBService.open();
    const userObjectStore = this.dexieDBService.table('user');

    // Retrieve the user object from the object store
    const userToUpdate = await userObjectStore.get('ssn');

    if (userToUpdate) {
      // Update the user object with new values
      const updatedUser = {...userToUpdate, ...user};

      // Update the user object in the object store
      await userObjectStore.put(updatedUser);
    } else {
      console.error('User not found in IndexedDB');
    }
  }

  async getUserFullname() {
    try {
      const userObject = await this.dexieDBService.transaction('r', this.dexieDBService.table('user'), async () => {
        return this.dexieDBService.table('user').get('ssn');
      });

      return userObject ? `${userObject['nom']} ${userObject['prenom']}` : null;
    } catch (error) {
      console.error('Error retrieving fullname from IndexedDB', error);
      return null;
    }
  }
}
